module.exports = __webpack_public_path__ + "images/travelcare3fbc65ba5eda37c6aa7f522026b5010f.png";